if (!customElements.get('product-favorite')) {
  class ProductFavorite extends HTMLElement {
    constructor() {
      super();
  
      // const
      this.typeAdd = "add_favorite";
      this.typeRemove = "remove_favorite";
      this.productId = this.dataset.productId;
      this.customerId = this.dataset.customerId;

      // element
      this.elFavoriteCount = this.querySelector('.js-favorite-count');
  
      // member variables


      this.initFavoriteButton()
    }
  
    initFavoriteButton () {
      this.addEventListener('click', () => {
        if (!this.customerId) {
          this.showGuestModal();
          return;
        }

        this.actionType = this.dataset.favoriteAction === this.typeAdd ? this.typeAdd : this.typeRemove;
  
        const formData = new FormData();
        formData.append('type', this.actionType);
        formData.append('product_id', this.productId);
        formData.append('customer_id', this.customerId);
        formData.append('ids', "");
        formData.append('data', "");
  
        console.log("this.actionType: ", this.actionType);
        console.log("this.productId: ", this.productId);
        console.log("this.customerId: ", this.customerId);
        console.log("formData: ", formData);
        console.log("formData.get('type'): ", formData.get('type'));
        console.log("formData.get('product_id'): ", formData.get('product_id'));
        console.log("formData.get('customer_id'): ", formData.get('customer_id'));
        console.log("formData.get('ids'): ", formData.get('ids'));
        console.log("formData.get('data'): ", formData.get('data'));

        startTrigger(formData, this.afterFavoriteSubmit.bind(this));
      });
    }
  
    afterFavoriteSubmit(data) {
      // 商品ページでのみ、お気に入り数の更新処理を追加
      if (this.elFavoriteCount && this.dataset.productTemplateFlg === "1") {
        this.updateFavoriteCount();
      }

      const modalJson = this.getFavoriteModalJson();
      this.switchFavoriteAction();
      openTriggerModal(modalJson, this.modalCallBack.bind(this))
    }
  
    getFavoriteModalJson () {
      if (this.actionType === this.typeAdd) {
        return {
          size: "small",
          class: "favorite-modal-add",
          fields: [
            {
              type: "product",
              class: "favorite-modal-add__product",
              title: this.dataset.productTitle,
              image: this.dataset.productImage,
            },
            {
              type: "html",
              class: "add-favorite-content",
              content:  this.getAddFavoriteContent("add-favorite-content"),
            }
          ]
        }
      } else {
        return {
          size: "small",
          class: "favorite-modal-remove",
          title: "お気に入りから削除しました。",
          fields: []
        }
      }
    }
  
    showGuestModal () {
      const modalJson = {
        size: 'medium',
        class: 'favorite-guest-modal',
        fields: [
          {
            type: "html",
            class: "favorite-guest-content",
            content:  this.getGuestContent("favorite-guest-content"),
          }
        ]
      }
  
      openTriggerModal(modalJson, this.modalCallBack.bind(this));
    }
    
    updateFavoriteCount() {
      const currentCount = Number(this.elFavoriteCount.textContent);
      if (this.actionType === this.typeAdd) {
        this.elFavoriteCount.textContent = currentCount + 1;
      } else {
        const newCount = currentCount - 1;
        this.elFavoriteCount.textContent = newCount < 0 ? 0 : newCount;
      }
    }
  
    switchFavoriteAction() {
      this.actionType = this.dataset.favoriteAction === this.typeAdd ? this.typeRemove : this.typeAdd;

      // 同じ商品IDのお気に入りアイコンを切り替える
      const elFavoriteButtons = document.querySelectorAll(`.js-product-favorite[data-product-id="${this.productId}"]`);
      for (const elBtn of elFavoriteButtons) {
        elBtn.setAttribute('data-favorite-action', this.actionType);
      }
    }
  
    getAddFavoriteContent(addFavoriteContent) {
      return `
        <div>
          <p class="${addFavoriteContent}__message">お気に入りに登録しました。</p>
        </div>
      `;
    }
  
    getGuestContent(guestContentClass) {
      return `
        <div class="${guestContentClass}__block block--login">
          <div>お気に入り商品を登録するには、ログインが必要です</div>
          <a class="${guestContentClass}__btn" href="/account/login">
            <svg class="icon icon-login" xmlns="http://www.w3.org/2000/svg" width="19.04" height="23" viewBox="0 0 19.04 23">
              <path id="パス_398" data-name="パス 398" d="M26.2,25.649c0-4.7-2.86-8.866-9.24-10.7s-5.059-11.3.22-11.3,6.6,9.461.22,11.3-9.24,6-9.24,10.7" transform="translate(-7.656 -3.149)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </svg>
            ログイン
            <svg class="icon icon-slide-right" id="icn_slide_right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="30.724" viewBox="0 0 20 30.724">
              <defs>
                <clipPath id="clip-path">
                  <rect id="長方形_17" data-name="長方形 17" width="20" height="30.724" fill="none"/>
                </clipPath>
              </defs>
              <g id="グループ_19" data-name="グループ 19" clip-path="url(#clip-path)">
                <path id="パス_12" data-name="パス 12" d="M14.4,15.362,0,.961a3.275,3.275,0,0,1,4.633,0l14.4,14.4-14.4,14.4a3.276,3.276,0,0,1-4.633,0v0Z" transform="translate(0.963 0)" fill="#f6b79e"/>
                <path id="パス_13" data-name="パス 13" d="M3.406,29.31a3.278,3.278,0,0,1,0-4.633l9.77-9.77L3.406,5.139a3.278,3.278,0,0,1,0-4.633l14.4,14.4Z" transform="translate(-2.448 0.453)" fill="#eee"/>
              </g>
            </svg>
          </a>
        </div>
        <div class="${guestContentClass}__block block--register">
          <div>会員登録をされていないお客様はこちら</div>
          <a class="${guestContentClass}__btn" href="/account/register">
            会員登録
            <svg class="icon icon-slide-right" id="icn_slide_right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="30.724" viewBox="0 0 20 30.724">
              <defs>
                <clipPath id="clip-path">
                  <rect id="長方形_17" data-name="長方形 17" width="20" height="30.724" fill="none"/>
                </clipPath>
              </defs>
              <g id="グループ_19" data-name="グループ 19" clip-path="url(#clip-path)">
                <path id="パス_12" data-name="パス 12" d="M14.4,15.362,0,.961a3.275,3.275,0,0,1,4.633,0l14.4,14.4-14.4,14.4a3.276,3.276,0,0,1-4.633,0v0Z" transform="translate(0.963 0)" fill="#f6b79e"/>
                <path id="パス_13" data-name="パス 13" d="M3.406,29.31a3.278,3.278,0,0,1,0-4.633l9.77-9.77L3.406,5.139a3.278,3.278,0,0,1,0-4.633l14.4,14.4Z" transform="translate(-2.448 0.453)" fill="#eee"/>
              </g>
            </svg>
          </a>
        </div>
      `;
    }
  
    modalCallBack() {
      // openTriggerでsubmitするボタンを設置していないため、この関数は実行されないが、エラー回避のため一応渡しておく
      console.log('DONE');
    }
  }
  
  customElements.define('product-favorite', ProductFavorite);
}
